<template>
	<div>
		<Layout :navFixed="true" :withImage="true" :loading="loading"  :hideFooterDecoration="true">
				
			
			<div class="container-fluid bg-white" v-if="item" >
				<div v-if="item.imageDetail" class="main-image" :style="'background-image:url(' + item.imageDetail.url + ')'">
					<div class="container" >
						<div class="row">
							<div class="col">
								<div class="data">
									<h3 class="category" v-if="item.category">{{ item.category.title }}</h3>
									<h1 class="title">
										<strong>{{ item.name }}</strong>
									</h1>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="container pb-4 pt-4" >
					<div class="row">
						<div class="col">
							<div v-html="item.detail"></div>
						</div>
						<div class="col col-lg-4">

							<div class="data">
								<div class="mt-3">
									<div class="data-item" v-if="item.dimensions">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-dimensions"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path d="M3 5h11"></path>
											<path d="M12 7l2 -2l-2 -2"></path>
											<path d="M5 3l-2 2l2 2"></path>
											<path d="M19 10v11"></path>
											<path d="M17 19l2 2l2 -2"></path>
											<path d="M21 12l-2 -2l-2 2"></path>
											<rect x="3" y="10" width="11" height="11" rx="2"></rect>
										</svg>
										{{ item.dimensions }}
									</div>
									<div class="data-item" v-if="item.capacity">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-users"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<circle cx="9" cy="7" r="4"></circle>
											<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
											<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
											<path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
										</svg>
										{{ item.capacity }}
									</div>
									<div class="data-item" v-if="item.waterTank">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-droplet"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path d="M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"></path>
										</svg>
										{{ item.waterTank }}
									</div>
								</div>
							</div>
							<div>
								<router-link
									tag="a"
									:to="`/contacto?body=${encodeURI(`Buenos días/nDeseo obtener más información acerca del vehículo ${this.item.name}/n¡Muchas gracias!`)}`"
									class="btn btn-block btn-primary mt-4 ml-2"
									v-if="!callme"
								>
									Me interesa
								</router-link>
							</div>
							
							<div class="image-gallery-container ml-2 mt-4" v-if="item.gallery">
								<div v-for="(image, i) in item.gallery.slice(0,10)" :key="image.id" @click="openGallery(i)">
									<div class="image" :style="'background-image:url(' + image.url + ')'">
										<div class="zoom">
											<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-zoom"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
										</div>
									</div>
								</div>
							</div>

							<div class="p-2 mt-4">
								<div class="video-container " v-if="item.youtubeLink">
									<iframe
										class="video"
										:src="`https://www.youtube.com/embed/${item.youtubeLink}`"
										frameborder="0"
										allowfullscreen
									>
									</iframe>
								</div>
							</div>
						</div>
								
					</div>
				</div>
			</div>

			<!-- <div class="">

				<VueSlickCarousel
					:arrows="true"
					:dots="false"
					:slidesToShow="4"
					:slidesToScroll="2"
					:infinite="true"
					:autoplay="true"
					v-if="!loading && item && item.gallery.length > 0"
				>
					<div v-for="image in item.gallery" :key="image.id">
						<div class="image-gallery" :style="'background-image:url(' + image.url + ')'">
						</div>
					</div>
				</VueSlickCarousel>
			</div> -->

			<LightBox ref="lightbox" :show-light-box="false" :media="mediaGallery"></LightBox>

		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import ProductCartBar from '@/components/ProductCartBar'
import BuyButton from '@/components/ecommerce/BuyButton'
import gql from 'graphql-tag'
import LightBox from 'vue-image-lightbox'

export default {
	name: 'ProductDetail',
	metaInfo() {
		return {
			title: this.item ? this.item.name : '',
		}
		
	},
	components: {
		Layout,
		ProductCartBar,
		BuyButton,
		LightBox,
	},
	data() {
		return {
			loading: true,
			item: {},
			callme: false,
			phone: null,
			sending: false,
			sended: false,
			scrolled: false,
			mediaGallery: [],
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},

	beforeMount() {
		if (this.$route.params.slug) {
			this.load()
		} else {
			this.$router.push('/')
		}
	},
	methods: {
		onScroll(e) {
			const dataContent = document.getElementsByClassName('data')[0]
			if (dataContent) {
				let diff = 0
				if (dataContent.clientHeight > window.innerHeight) {
					diff = dataContent.clientHeight - window.innerHeight
				}
				diff = diff + 100

				window.top.scrollY > diff ? (this.scrolled = true) : (this.scrolled = false)
			}
		},
		callMePlease() {
			this.callme = true
			this.$nextTick(() => {
				this.$refs.phoneInput.focus()
			})
		},
		callMePleaseClose() {
			this.callme = false
		},
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String) {
							camper(slug: $slug) {
								id
								name
								image {
									id
									type
									filename
									url
									urlThumb
								}
								imageDetail {
									id
									type
									filename
									url
									urlThumb
								}
								gallery {
									id
									type
									filename
									url
									urlThumb
								}
								dataSheet {
									id
									type
									filename
									url
									urlThumb
								}
								category {
									id
									title
								}
								detail
								dimensions
								capacity
								waterTank
								youtubeLink
							}
						}
					`,
					variables: { slug: this.$route.params.slug },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.item = data.camper
					
					this.item.gallery.map((image) => {
						if(image.type == "image"){
							this.mediaGallery.push({
								thumb: image.urlThumb,
								src: image.url,
								caption: '...',
							})
						}
					})
					console.log(this.mediaGallery)

					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					this.$router.push('/')
				})
		},
		send() {
			if (!this.sending && this.phone) {
				this.sending = true
				const data = {
					subject: 'Solcitud de llamada',
					name: 'No definido',
					phone: this.phone,
					email: 'No definido',
					message: `Interesado en vehículo ${this.item.name} solciita ser llamado al teléfono ${this.phone}`,
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: MessageInput!) {
								messageCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data,
						},
					})
					.then(() => {
						this.sending = false
						this.sended = true
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.sending = false
					})
			}
		},
		openGallery(index) {
			this.$refs.lightbox.showImage(index)
		}
	},
}
</script>

<style scoped lang="scss">

.video-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
	.video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}

.image-gallery-container{
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 6px;

	.image{

		width: 100%;
		height: 100px;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
		position: relative;
		border-radius: 4px;

		.zoom{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #00000050;
			display: flex;
			justify-content: center;
			align-items: center;
			opacity: 0;
			transition: all 0.3s ease-in-out;
			cursor: pointer;
			svg{
				width: 40px;
				height: 40px;
				color: #fff;
			}
		}
		&:hover .zoom{
			opacity: 1;
		}
	}

}

.main-image {
	width: 100%;
	height: 540px;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;

	
	.data{
		padding: 18px;
		color: #fff;
		position: absolute;
		top: 310px;
		z-index: 10;
		background-color: #00000030;
	}

	&:before{
		content:'';
		background-image: url('~@/assets/img/banner-shap.png');
		width: 100%;
		height: 10vw;
		position: absolute;
		background-size: cover;
		background-position: center bottom;
		background-repeat: no-repeat;
		bottom: 0px;

	}
}

.data{
	

	.title{
		font-size: 3rem;
	}
	.category {
		font-size: 20px;
		text-transform: uppercase;
		color: #fff;
	}
}

.data-item {
	display: flex;
	padding: 4px;
	align-items: center;
	font-size: 13px;

	svg {
		width: 18px;
		margin-right: 8px;
	}
}



.badge-primary {
	background-color: #ec9721;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 500;
}

.image-gallery{
	width: 100%;
	height: 300px;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;

}

::v-deep .slick-arrow{
	width: 50px;
	height: 50px;
	    z-index: 10;
	
	&.slick-prev{
		left: 36px;
		&:before{
			font-size: 40px;
		}
	}
	&.slick-next{
		right: 36px;
		&:before{
			font-size: 40px;
		}
	}
}

.btn.btn-call {
	height: 44px;
	transition: all 0.3s ease-in-out;
}
.btn.callme {
	display: flex;
	padding: 4px;
	align-items: center;
	background-color: #000000;
	input {
		border-radius: 20px;
		border: none;
		height: 34px;
		padding-left: 12px;
		width: 120px;
		font-size: 18px;
		margin: 0px 6px;
		outline: none;
	}
	.icon {
		margin-left: 8px;
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}
	.btn-primary {
		background-color: #5a5a5a;
		color: #fff;
		height: 34px;
		align-items: center;
		padding: 0px 12px;
	}
}


.data-sheet {
	display: flex;
	align-items: center;

	.content {
		padding: 22px 15px;
		position: relative;
		background-color: #f3f3f3;
		flex-grow: 1;

		&:before {
			content: '';
			border-top: 0px solid transparent;
			border-left: 26px solid transparent;
			border-bottom: 120px solid white;
			position: absolute;
			top: 0px;
			right: 0px;
		}
	}
	h4 {
		font-weight: bold;
	}
	.btn {
		margin-left: 30px;
	}
}


@media (min-width: 750px) {

	
}
</style>
